import React, { useState } from "react";
import {
  CALENDER_ICON,
  FILTER,
  OVERVIEW_1,
  OVERVIEW_2,
  OVERVIEW_3,
  ARROW_UP,
} from "../../../assets";
import TableComponent from "../../../shared/components/table";
import { PresidentOverviewCauseListColumns } from "../../../shared/components/table/columns/presidentOverviewCauseList";
import { SortingState } from "@tanstack/react-table";

const Overview = () => {
  const [sorting, setSorting] = useState<SortingState>([]);

  const stats = [
    {
      icon: OVERVIEW_1,
      value: "75",
      title: "Total case folders ready for assignment",
      subtitle: "0% from last month",
    },
    {
      icon: OVERVIEW_2,
      value: "75",
      title: "Total case folders assigned",
      subtitle: "0% from last month",
    },
    {
      icon: OVERVIEW_3,
      value: "75",
      title: "Total case folders concluded",
      subtitle: "0% from last month",
    },
  ];

  const causeListData = [
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      task_title: "",
      appeal_number: "CV/3047/2018",
      status: "Submitted (CJ)",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      task_title: "",
      appeal_number: "CV/3047/2018",
      status: "Submitted (CJ)",
    },
    {
      sn: false,
      date: "31-05-2024",
      title: "Olugbenga Akintola vs Israel Anyemalu",
      details: "View",
      task_title: "",
      appeal_number: "CV/3047/2018",
      status: "Submitted (CJ)",
    },
  ];

  return (
    <div className="flex flex-col gap-y-8 p-8 min-h-screen">
      {/* Greeting */}
      <div>
        <h1 className="text-2xl font-bold text-[#101828]">Hi Ademola,</h1>
        <p className="text-sm text-[#667085]">
          Hi, Samantha. Welcome back to Sedap Admin!
        </p>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl border border-[#E4E7EC] px-6 py-5 flex items-center gap-4 shadow-sm"
          >
            <div className="min-w-[84px] h-[85px] rounded-full bg-[#E6F7F1] flex items-center justify-center">
              <img
                src={stat.icon}
                alt=""
                className="w-[58.67px] h-[43.23px] object-contain"
              />
            </div>
            <div className="flex flex-col gap-0.5">
              <span className="text-[40px] font-bold text-[#464255] leading-tight">
                {stat.value}
              </span>
              <span className="text-xs font-medium text-[#807D8B]">
                {stat.title}
              </span>
              <div className="flex items-center gap-2 mt-1">
                <div className="w-5 h-5 rounded-full bg-[#E6F7F1] flex items-center justify-center">
                  <img
                    src={ARROW_UP}
                    alt=""
                    className="w-[5.65px] h-[5.65px]"
                  />
                </div>
                <span className="text-xs text-[#A3A3A3]">{stat.subtitle}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Cause List */}
      <div className="bg-white rounded-2xl border border-[#E4E7EC] px-6 py-5 mt-2">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-[#101828]">Cause List</h2>
        </div>

        <div className="flex flex-wrap items-center gap-3 mb-6">
          <button className="flex items-center gap-2 px-4 py-2.5 rounded-lg border border-[#D0D5DD] bg-white text-sm text-[#667085]">
            <img src={CALENDER_ICON} alt="" className="w-5 h-5" />
            <span>Start date – End date</span>
          </button>
          <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#005C3C] text-sm font-semibold text-white">
            <img src={FILTER} alt="" className="w-4 h-4 filter invert" />
            <span>Filters</span>
          </button>
        </div>

        <TableComponent
          DATA={causeListData}
          // @ts-ignore
          COLUMNS={PresidentOverviewCauseListColumns}
          sorting={sorting}
          setSorting={setSorting}
        />

        {/* Pagination */}
        <div className="flex items-center justify-between mt-6 text-sm text-[#667085]">
          <div></div>
          <div className="flex items-center gap-3">
            <span>Page 1 of 1</span>
            <div className="flex items-center gap-2">
              <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                Previous
              </button>
              <button className="px-3 py-1.5 rounded-lg border border-[#D0D5DD] bg-white hover:bg-gray-50">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;
